import { SubActivityEdit } from '../../sub-activity/sub-activity-edit';
import { EditProps } from './settings/interactive-response.constants';
import InteractiveResponseSequencePlayPreview from './play/interactive-response-sequence-play-preview';
import * as Styled from '../interactive-response.style';
import { ComponentActions } from '../../components.style';
import ComponentAltTextButton from '../../shared/component-alt-text/component-alt-text-button';
import { useActivityBuilderContext } from 'approot/activity-builder/activity-builder.context';
import { getComponentSelectorId } from '../../shared/logic/get-component-selector-id';
import { LANGUAGE_CODE_EN_AU } from 'global/constants';
import { isTextVariant } from '../shared/interactive-response-shared.utils';

const InteractiveResponseEdit = (props: EditProps) => {
  const {
    id,
    sectionId,
    type,
    sort,
    subActivityProperties,
    properties,
    version,
  } = props;
  const { openDrawer } = useActivityBuilderContext();

  return (
    <SubActivityEdit
      id={id}
      component={{
        id,
        type,
        sort,
        properties,
        sectionId,
        language: LANGUAGE_CODE_EN_AU,
        version,
        __typename: 'ActivitiesInteractiveResponseComponent',
      }}
      subActivityDetails={subActivityProperties}
    >
      {container => (
        <Styled.InteractiveResponseContainer
          id={getComponentSelectorId(props.id)}
          data-selector="interactive-response-container"
        >
          <InteractiveResponseSequencePlayPreview
            {...props}
            shuffleItems={false}
            instructionHeight={container?.offsetHeight || 0}
          />
          {!isTextVariant(properties.interactiveResponse.variant) &&
            properties.interactiveResponse.items.length > 0 && (
              <ComponentActions>
                <ComponentAltTextButton
                  hasAltText={
                    !!properties.interactiveResponse.items.every(
                      item => item.image?.description
                    )
                  }
                  onClick={() => openDrawer({ componentId: id })}
                />
              </ComponentActions>
            )}
        </Styled.InteractiveResponseContainer>
      )}
    </SubActivityEdit>
  );
};

export default InteractiveResponseEdit;
